import React from 'react';
import { Logger } from '@datadog/browser-logs';

export type LoggerContextType = {
  planningLogger?: Logger;
};

export const LoggerContext = React.createContext<LoggerContextType>({});
